import { useTranslation } from "react-i18next";
import type { BudgetSection, BudgetSubcategory } from "../../../types";
import CategoryList from "./CategoryList";
import ExpenseBreakdownChart from "./ExpenseBreakdownChart";

interface Props {
  section: BudgetSection;
  expenseBreakdownData: Record<string, string | number>[];
  isChartLoading: boolean;
  onSubcategoryClick: (subcategory: BudgetSubcategory) => void;
  hidePlanned?: boolean;
}

export default function CategoriesSection({
  section,
  expenseBreakdownData,
  isChartLoading,
  onSubcategoryClick,
  hidePlanned = false,
}: Props) {
  const { t } = useTranslation("FinancePage");

  if (!section.subcategories.length) return null;

  return (
    <div className="radius-sm surface-component-fill p-4">
      <div className="flex justify-between items-center gap-5 mb-4">
        <h2 className="text-body-bold-lg content-base-primary">{t("categories.title")}</h2>
      </div>
      <div className="grid grid-cols-[1fr_2fr] gap-3 min-h-0 items-stretch">
        <div className="min-w-0 h-full">
          <CategoryList subcategories={section.subcategories} onSubcategoryClick={onSubcategoryClick} hidePlanned={hidePlanned} />
        </div>
        <div className="min-w-0 surface-base-fill radius-sm p-5 flex flex-col">
          <h3 className="text-body-bold-lg content-base-primary mb-4">{t("categories.dynamics")}</h3>
          <ExpenseBreakdownChart
            data={expenseBreakdownData}
            subcategories={section.subcategories}
            isLoading={isChartLoading}
          />
        </div>
      </div>
    </div>
  );
}

